








import Vue from "vue";
import ForcesTable from "@/components/forces/ForcesTable.vue";

export default Vue.extend({
  name: "ForceList",
  components: { ForcesTable },
});
